enum DictionaryTypes {
  Dictionary,
  UserDictionary
}

export default DictionaryTypes;